import React, {useEffect} from 'react'
import './panels.scss'
import {getActivities, getCustomerActivities} from "../requests/requests-slice";
import {useAppDispatch, useAppSelector} from "../../core/hooks";
import {setDate} from "../../services/utils";

const HistoryPanel = ({isDpSentry = false, selectedModalBrigade}) => {
  const {activities} = useAppSelector(state => state.requests)
  const dispatch = useAppDispatch()
  useEffect(() => {
    if (isDpSentry && selectedModalBrigade) {
      dispatch(getCustomerActivities(selectedModalBrigade))
    }else {
      dispatch(getActivities())
    }
  }, [dispatch, isDpSentry, selectedModalBrigade])

  return (
    <div id='history-panel'>
      {
        activities?.map((el, i) => {
          return <div key={i} className="text-wrapper">
            <p className="text">{el.message}</p>
            <div className={'flex-row'}>
              {el.data?.priority && <p className={'priority mr-20'}>Приоритет: {el.data.priority}</p>}
              {el.data?.diagnosis && <p className={'priority mr-20'}>Диагноз: {el.data.diagnosis}</p>}
              {el.data?.diagnosis_details && <p className={'priority mr-20'}>Комментарий: {el.data.diagnosis_details}</p>}
              {el.data?.hospital_name && <p className={'priority mr-20'}>Стационар: {el.data.hospital_name}</p>}
              {el.data?.hospital_address && <p className={'priority mr-20'}>Адрес: {el.data.hospital_address}</p>}
              {el.data?.change_reason && <p className={'priority mr-20'}>Причина: {el.data.change_reason}</p>}
              {el.data?.change_comment && <p className={'priority mr-20'}>Комментарий: {el.data.change_comment}</p>}
              {el.data?.reject_reason && <p className={'priority mr-20'}>Комментарий: {el.data.reject_reason}</p>}
              {el.data?.hospital_comment && <p className={'priority mr-20'}>Причина замены: {el.data.hospital_comment}</p>}
              <p className="date">{setDate(el.updated_at)}</p>
            </div>
          </div>
        })
      }
    </div>
  )
}

export default HistoryPanel
